import { SVGAttributes, ReactElement } from 'react'

type Props = SVGAttributes<SVGElement>

function CobaltLogoMark(props: Props): ReactElement {
    const { fill } = props
    const fillColor = fill ?? '#000'

    return (
        <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect y="-0.130566" width="88" height="88" rx="14" fill="#4A2DFF" />
            <rect
                y="-0.130566"
                width="88"
                height="88"
                rx="14"
                fill="url(#paint0_linear_2872_11573)"
                fillOpacity="0.1"
                style={{ mixBlendMode: 'multiply' }}
            />
            <rect
                y="-0.130566"
                width="88"
                height="88"
                rx="14"
                fill="url(#paint1_linear_2872_11573)"
                fillOpacity="0.2"
                style={{ mixBlendMode: 'screen' }}
            />
            <g filter="url(#filter0_d_2872_11573)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M70.2288 17.8588C71.8454 19.4693 72.4779 21.821 71.8874 24.025L60.1719 67.7476C59.2607 71.1484 55.7651 73.1667 52.3642 72.2554C48.9634 71.3441 46.9452 67.8485 47.8564 64.4477L56.7015 31.4375L23.0499 40.435C19.6525 41.3592 16.1493 39.3542 15.2251 35.9569C14.301 32.5596 16.3059 29.0563 19.7033 28.1322L64.0563 16.2237C66.2582 15.6247 68.6123 16.2484 70.2288 17.8588ZM51.6833 36.4775L44.333 63.6833C43.4217 67.0841 39.9262 69.1022 36.5253 68.191C33.1245 67.2797 31.1063 63.7842 32.0176 60.3834L33.5306 54.6289L27.5623 56.1527C24.1649 57.0768 20.957 54.9865 20.0329 51.5892C19.1087 48.1919 20.8183 44.774 24.2157 43.8499L51.6833 36.4775Z"
                    fill={fillColor}
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2872_11573"
                    x="9"
                    y="15"
                    width="69.1047"
                    height="68.4742"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="3" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="multiply"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2872_11573"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2872_11573"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2872_11573"
                    x1="44"
                    y1="87.8694"
                    x2="44"
                    y2="-0.130566"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop />
                    <stop offset="1" stopColor={fillColor} />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2872_11573"
                    x1="44"
                    y1="87.8694"
                    x2="44"
                    y2="-0.130566"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop />
                    <stop offset="1" stopColor={fillColor} />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default CobaltLogoMark
